import styled from 'styled-components';
import colors from 'constants/colors';

export const Wrapper = styled.div`
  margin: 0 auto 10px;
  width: 990px;

  &:first-child {
    margin-top: 105px;
  }

  &:last-child {
    margin-bottom: 105px;
  }

  @media screen and (max-width: 992px) {
    margin: 0 auto 25px;
    width: 100%;

    &:first-child {
      margin-top: 0px;
    }

    &:last-child {
      margin-bottom: 80px;
    }
  }
`;

export const Section = styled.section`
  background: ${colors.main.white};
  border-radius: 2px;
  padding-top: 40px;
  position: relative;
  padding: 40px 30px 40px;

  @media screen and (max-width: 992px) {
    padding: 25px 20px 40px;
    overflow: hidden;
  }
`;
